import { useMemo } from "react";
import { useLocalStorage } from "@app/hooks/useLocalStorage";

export enum DftChartKind {
  indexPoints = "indexPoints",
  boxAndWhisker = "boxAndWhisker",
}

export const useDftChartKindSelector = (params: { storageKey: string }) => {
  const [chartSelection, setChartSelection] = useLocalStorage<DftChartKind>(
    params.storageKey,
    DftChartKind.indexPoints,
  );

  return useMemo(
    () => ({
      options: [
        {
          value: DftChartKind.indexPoints,
          label: "Index Points",
        },
        {
          value: DftChartKind.boxAndWhisker,
          label: "Box & Whisker",
        },
      ],
      value: chartSelection,
      onChange: (value: unknown) => setChartSelection(value as DftChartKind),
    }),
    [chartSelection, setChartSelection],
  );
};
